module.exports = __webpack_public_path__ + "img/txt_zodiac.4c6c0e9e.svg";